import { render, staticRenderFns } from "./MapaFuturo.vue?vue&type=template&id=1ff2d3cc&"
import script from "./MapaFuturo.vue?vue&type=script&lang=js&"
export * from "./MapaFuturo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports